export const ENV = process.env.NODE_ENV;

export const getAPIUrl = (): string => {

  if (ENV === 'local') {
    return 'https://localhost:5041/api';
  }
  return process.env.REACT_APP_PORTAL_API as string;
};
